import React from 'react';
import classNames from 'classnames';
// import { Panel } from 'react-bootstrap';

import LoadingSpinner from '../../shared/LoadingSpinner';
import Job from './Job';
import styles from './AvailableJobs.css';

const Results = ({ activeCrew, detailEnabled, financialEnabled, jobs, loading, locationEnabled, onJobClick, ...props }) => (
  <div className="panel panel-default" {...props}>
    <div className={classNames('panel-body', styles.searchResultsContainer)}>
      {loading && <LoadingSpinner />}
      {jobs.map((j) => (
        <Job
          activeCrew={activeCrew}
          detailEnabled={detailEnabled}
          financialEnabled={financialEnabled}
          job={j}
          key={j.id}
          locationEnabled={locationEnabled}
          onClick={() => onJobClick(j.id)}
        />
      ))}
    </div>
  </div>
);

export default Results;
